var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "change_dark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9372",
    "data-name": "Group 9372"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13517",
    "data-name": "Rectangle 13517",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13518",
    "data-name": "Rectangle 13518",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9374",
    "data-name": "Group 9374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9373",
    "data-name": "Group 9373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47970",
    "data-name": "Path 47970",
    d: "M3.01,10.72A4.985,4.985,0,0,0,7.08,15.9l-.79-.79a1,1,0,0,1,0-1.41h0a1,1,0,0,1,1.41,0l2.59,2.59a1,1,0,0,1,0,1.41L7.71,20.3a1,1,0,0,1-1.41,0h0a1,1,0,0,1,0-1.41l.88-.88v-.06a7,7,0,0,1-6.15-7.47A7.16,7.16,0,0,1,8.26,4H10a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H8.22A5.141,5.141,0,0,0,3.01,10.72Z",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47971",
    "data-name": "Path 47971",
    d: "M15,11h5a2.006,2.006,0,0,0,2-2V6a2.006,2.006,0,0,0-2-2H15a2.006,2.006,0,0,0-2,2V9A2.006,2.006,0,0,0,15,11Zm5-2H15V6h5Z",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47972",
    "data-name": "Path 47972",
    d: "M20,20H15a2.006,2.006,0,0,1-2-2V15a2.006,2.006,0,0,1,2-2h5a2.006,2.006,0,0,1,2,2v3A2.006,2.006,0,0,1,20,20Z",
    fill: "#4b4e6d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeDark);
export default __webpack_public_path__ + "static/media/change_dark.d8117702d3621e27ae86329f5db94ab0.svg";
export { ForwardRef as ReactComponent };